<script>
import csFile from './cs.js';
import daFile from './da.js';
import deFile from './de.js';
import elFile from './el.js';
import enFile from './en.js';
import esFile from './es.js';
import fiFile from './fi.js';
import frFile from './fr.js';
import heFile from './he.js';
import huFile from './hu.js';
import idFile from './id.js';
import itFile from './it.js';
import jaFile from './ja.js';
import koFile from './ko.js';
import msFile from './ms.js';
import nlFile from './nl.js';
import noFile from './no.js';
import plFile from './pl.js';
import ptFile from './pt.js';
import roFile from './ro.js';
import svFile from './sv.js';
import thFile from './th.js';
import trFile from './tr.js';
import viFile from './vi.js';
import zhHansFile from './zh_hans.js';
import zhHantFile from './zh_hant.js';

export default {
    methods: {
        setLanguageFile() {
            let languageFile = '';

            switch (this.$store.state.page.language) {
                case 'cs':
                    languageFile = csFile;
                    break;

                case 'da':
                    languageFile = daFile;
                    break;

                case 'de':
                    languageFile = deFile;
                    break;

                case 'el':
                    languageFile = elFile;
                    break;

                case 'en':
                    languageFile = enFile;
                    break;

                case 'es':
                    languageFile = esFile;
                    break;

                case 'fi':
                    languageFile = fiFile;
                    break;

                case 'fr':
                    languageFile = frFile;
                    break;

                case 'he':
                    languageFile = heFile;
                    break;

                case 'hu':
                    languageFile = huFile;
                    break;

                case 'id':
                    languageFile = idFile;
                    break;

                case 'it':
                    languageFile = itFile;
                    break;

                case 'ja':
                    languageFile = jaFile;
                    break;

                case 'ko':
                    languageFile = koFile;
                    break;

                case 'ms':
                    languageFile = msFile;
                    break;

                case 'nl':
                    languageFile = nlFile;
                    break;

                case 'no':
                    languageFile = noFile;
                    break;

                case 'pl':
                    languageFile = plFile;
                    break;

                case 'pt':
                    languageFile = ptFile;
                    break;

                case 'ro':
                    languageFile = roFile;
                    break;

                case 'sv':
                    languageFile = svFile;
                    break;

                case 'th':
                    languageFile = thFile;
                    break;

                case 'tr':
                    languageFile = trFile;
                    break;

                case 'vi':
                    languageFile = viFile;
                    break;

                case 'zh_hans':
                    languageFile = zhHansFile;
                    break;

                case 'zh_hant':
                    languageFile = zhHantFile;
                    break;
            }

            this.$store.commit('page/setLanguageFile', new languageFile());
        },

        getTranslation(name) {
            const placeholder = this.$store.getters['form/getFieldData']('placeholder', name);
            let translation = this.$store.state.page.languageFile.preValidateFormFields(name);
            translation = translation.replace('%s', placeholder);

            return translation;
        },
    },
};
</script>
